import { DashboardPage } from "@/features/dashboard/pages/Dashboard";

export const Dashboard = () => {
  return <DashboardPage />;
};

export default Dashboard;
